import type { IVaultNavHistory, Vault, } from "@bracket/types";
import type { DateTime, } from "luxon";
import { getEpochStartTime, } from "./getEpochStartTime";



export const getEpochEndTime = ({
	vault,
	epoch,
}: { vault: Vault & IVaultNavHistory, epoch: number, }): DateTime => {

	const start = getEpochStartTime({ vault, epoch, });
	const nav = vault.navs.find((nav) => nav.epoch === epoch);
	if(!nav) {
		throw new Error(`getEpochEndTime failed to find nav for epoch ${epoch} for vault ${vault.symbol}`);
	}
	const { epoch_duration_days, } = nav;
	return start.plus({ days: epoch_duration_days, });
};
